import { usePlanGroup } from '../queries/usePlanGroup';

const DEFAULT_CURRENCY = 'USD';
const DEFAULT_COUNT = 0;

export const useIsSocialStarter = () => {
  const { data, isLoading, error } = usePlanGroup(DEFAULT_CURRENCY, DEFAULT_COUNT);

  return { isSocialStarter: data?.isSocialStarter(), isCustomer: data?.isCustomer(), isLoading, error };
};

export type UseIsSocialStarter = ReturnType<typeof useIsSocialStarter>;
